import { AttachmentState } from 'owa-attachment-full-data';
import ItemId from 'owa-service/lib/contract/ItemId';
import { AttachmentType, SmimeAttachmentType } from 'owa-attachment-model-store';
import getAttachment from 'owa-attachment-model-store/lib/selectors/getAttachment';
import updateSmimeAttachment from 'owa-attachment-full-data/lib/actions/updateSmimeAttachment';
import { getUserMailboxInfo } from 'owa-client-ids';

/**
 * Update attachmentIds received from server for S/MIME attachment.
 */
const updateSmimeAttachmentIds = (
    smimeAttachments: AttachmentState[],
    attachmentIdsFromServer: AttachmentType[],
    itemId: ItemId
) => {
    smimeAttachments.forEach((smimeAttachment, index) => {
        // Reset content property to avoid uploading in next save.
        const attachmentModel = getAttachment(smimeAttachment.attachmentId);
        const attachmentType = attachmentModel && (attachmentModel.model as SmimeAttachmentType);

        attachmentType.Content = null;
        attachmentType.MimeContent = null;

        // This is the createItem scenario, we have the uploaded attachmentIds
        // Call updateSmimeAttachment with itemId(composeId) to avoid deleting the attachment from the store
        // since the attachments point to parentItem, create new attachment in the attachment store
        if (attachmentIdsFromServer && index <= attachmentIdsFromServer.length) {
            const attachmentFromServer: AttachmentType = {
                ...attachmentType,
                ...attachmentIdsFromServer[index],
            };
            const newAttachmentId = {
                ...attachmentIdsFromServer[index].AttachmentId,
                mailboxInfo: getUserMailboxInfo(),
            };

            updateSmimeAttachment(
                smimeAttachment,
                newAttachmentId,
                attachmentType,
                attachmentFromServer,
                itemId
            );
        }
    });
};

export default updateSmimeAttachmentIds;
